module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/efo_mv_bg-bc313cb3e94bfef4a5d1a82a3b552098.png";